import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Typography } from "@mui/material";

import { useAuth } from "authentication/AuthProvider";
import SelectOrganisationForm from "authentication/SelectOrganisationForm";

import OrganisationClient from "organisation/OrganisationClient";
import useGet from "utils/fetch/useGet";

export default function OrganisationSection(): JSX.Element {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { refreshTokens } = useAuth();
	const { response } = useGet(OrganisationClient.getAll());

	const onSelectOrganisation = useCallback(
		(id: number) => refreshTokens(id),
		[refreshTokens]
	);

	const onCreateOrganisation = useCallback(() => {
		navigate("/create-organisation");
	}, [navigate]);

	// TODO: better handling of loading & error
	return (
		<>
			<SelectOrganisationForm
				organisations={
					response.state === "SUCCESS" ? response.data : []
				}
				onSelectOrganisation={onSelectOrganisation}
				onCreateOrganisation={onCreateOrganisation}
			/>

			{response.state === "SUCCESS" && response.data.length === 0 && (
				<Typography
					variant="body2"
					aria-label="notice"
					sx={{ textAlign: "left", marginTop: 1 }}>
					{t("noOrganisations")}
				</Typography>
			)}
		</>
	);
}
